"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCardInVariant = instanceOfCardInVariant;
exports.CardInVariantFromJSON = CardInVariantFromJSON;
exports.CardInVariantFromJSONTyped = CardInVariantFromJSONTyped;
exports.CardInVariantToJSON = CardInVariantToJSON;
exports.CardInVariantToJSONTyped = CardInVariantToJSONTyped;
const card_1 = require("./card");
/**
 * Check if a given object implements the CardInVariant interface.
 */
function instanceOfCardInVariant(value) {
    if (!('card' in value) || value['card'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    if (!('battlefieldCardState' in value) || value['battlefieldCardState'] === undefined)
        return false;
    if (!('exileCardState' in value) || value['exileCardState'] === undefined)
        return false;
    if (!('libraryCardState' in value) || value['libraryCardState'] === undefined)
        return false;
    if (!('graveyardCardState' in value) || value['graveyardCardState'] === undefined)
        return false;
    if (!('mustBeCommander' in value) || value['mustBeCommander'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
function CardInVariantFromJSON(json) {
    return CardInVariantFromJSONTyped(json, false);
}
function CardInVariantFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'card': (0, card_1.CardFromJSON)(json['card']),
        'zoneLocations': json['zoneLocations'],
        'battlefieldCardState': json['battlefieldCardState'],
        'exileCardState': json['exileCardState'],
        'libraryCardState': json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'],
        'quantity': json['quantity'],
    };
}
function CardInVariantToJSON(json) {
    return CardInVariantToJSONTyped(json, false);
}
function CardInVariantToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'quantity': value['quantity'],
    };
}
//# sourceMappingURL=cardInVariant.js.map